export default class Form {
	constructor() {
		this.initWYSIWYGEditor();
		this.iosCheckbox();
		this.submitCRUDFormBtn();
		this.submitFormWithConfirmation();
		this.syncSummernoteOnSubmit();
		this.visibleIf();
		this.disabledIf();
		this.readonlyIf();
	}

	/**
	 * Pulisce l'HTML incollato da Word/Office rimuovendo:
	 * - Tag con namespace Office/Word (o:p, w:sdt, etc.)
	 * - Classi MsoNormal e simili
	 * - Stili mso-* inline
	 * - Commenti condizionali di Office
	 * - Attributi lang, dir ridondanti
	 * - Span vuoti e nesting inutile
	 */
	static cleanWordHTML(html) {
		if (!html) return html;

		// Rimuovi commenti condizionali Office <!--[if ...]>...<![endif]-->
		html = html.replace(/<!--\[if[\s\S]*?<!\[endif\]-->/gi, '');
		// Rimuovi commenti HTML normali
		html = html.replace(/<!--[\s\S]*?-->/g, '');

		// Rimuovi tag con namespace XML (o:p, v:*, w:*, m:*, etc.)
		html = html.replace(/<\/?\w+:[^>]*>/gi, '');

		// Rimuovi tag <style>...</style> di Word
		html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

		// Rimuovi tag <xml>...</xml>
		html = html.replace(/<xml[^>]*>[\s\S]*?<\/xml>/gi, '');

		// Rimuovi attributi class con valori Mso*
		html = html.replace(/\s*class\s*=\s*"[^"]*Mso[^"]*"/gi, '');
		html = html.replace(/\s*class\s*=\s*'[^']*Mso[^']*'/gi, '');

		// Rimuovi proprietà mso-* dagli stili inline
		html = html.replace(/\s*mso-[^:]+:[^;"']+;?/gi, '');

		// Rimuovi stili inline rimasti vuoti (style="")
		html = html.replace(/\s*style\s*=\s*"\s*"/gi, '');
		html = html.replace(/\s*style\s*=\s*'\s*'/gi, '');

		// Rimuovi attributi lang e dir inutili
		html = html.replace(/\s*lang\s*=\s*"[^"]*"/gi, '');
		html = html.replace(/\s*dir\s*=\s*"[^"]*"/gi, '');

		// Rimuovi namespace declarations
		html = html.replace(/\s*xmlns[^=]*\s*=\s*"[^"]*"/gi, '');

		// Rimuovi span senza attributi: <span>testo</span> → testo
		html = html.replace(/<span\s*>([\s\S]*?)<\/span>/gi, '$1');

		// Rimuovi font tags
		html = html.replace(/<\/?font[^>]*>/gi, '');

		// Pulisci spazi bianchi multipli
		html = html.replace(/(\s*\n\s*)+/g, '\n');

		return html.trim();
	}

	syncSummernoteOnSubmit() {
		// Forza la sincronizzazione di tutti gli editor Summernote prima del submit
		$('form').on('submit', function(e) {
			$(this).find('.editor').each(function() {
				if ($(this).summernote) {
					// Sincronizza il contenuto di Summernote con il textarea
					try {
						$(this).summernote('code', $(this).summernote('code'));
					} catch (err) {
						console.warn('Impossibile sincronizzare editor:', err);
					}
				}
			});
		});
	}

	initWYSIWYGEditor() {
		// Verifica che Summernote sia caricato prima di procedere
		if (typeof window.$ === 'undefined' || !window.$.fn.summernote) {
			console.warn('Summernote non è ancora caricato, riprovo tra 100ms...');
			setTimeout(() => {
				this.initWYSIWYGEditor();
			}, 100);
			return;
		}

		// Definisci il bottone personalizzato per i placeholder (se presente la modale)
		// Callback onPaste per pulire HTML da Word/Office
		const onPasteCallback = function(e) {
			const clipboardData = e.originalEvent && e.originalEvent.clipboardData;
			if (!clipboardData) return;

			const htmlData = clipboardData.getData('text/html');

			// Rileva se il contenuto proviene da Word/Office
			const isFromWord = htmlData && (
				htmlData.indexOf('class="Mso') !== -1 ||
				htmlData.indexOf('urn:schemas-microsoft-com:office') !== -1 ||
				htmlData.indexOf('<o:p>') !== -1 ||
				htmlData.indexOf('mso-') !== -1
			);

			if (isFromWord) {
				e.preventDefault();
				const cleanedHTML = Form.cleanWordHTML(htmlData);
				// Inserisci l'HTML pulito nell'editor
				$(this).summernote('pasteHTML', cleanedHTML);
			}
		};

		if ($('#placeholdersModal').length > 0) {
			const PlaceholderButton = function (context) {
				const ui = $.summernote.ui;
				
				const button = ui.button({
					contents: '<i class="fa fa-code"/> Placeholder',
					tooltip: 'Inserisci Placeholder',
					click: function () {
						$('#placeholdersModal').modal('show');
					}
				});
				
				return button.render();
			};

			window.editorDefaultConfig = {
				height: 250,
				toolbar: [
					['style', ['style']],
					['font', ['bold', 'underline', 'clear']],
					['para', ['ul', 'ol', 'paragraph']],
					['table', ['table']],
					['insert', ['link', 'picture', 'video', 'hr']],
					['view', ['fullscreen', 'codeview', 'help']],
					['mybutton', ['placeholder']]
				],
				buttons: {
					placeholder: PlaceholderButton
				},
				callbacks: {
					onPaste: onPasteCallback,
				},
				lang:
					$('html').attr('lang') +
					'-' +
					$('html')
						.attr('lang')
						.toUpperCase(),
			};
		} else {
			// Configurazione senza il bottone placeholder
			window.editorDefaultConfig = {
				height: 250,
				toolbar: [
					['style', ['style']],
					['font', ['bold', 'underline', 'clear']],
					['para', ['ul', 'ol', 'paragraph']],
					['table', ['table']],
					['insert', ['link', 'picture', 'video', 'hr']],
					['view', ['fullscreen', 'codeview', 'help']],
				],
				callbacks: {
					onPaste: onPasteCallback,
				},
				lang:
					$('html').attr('lang') +
					'-' +
					$('html')
						.attr('lang')
						.toUpperCase(),
			};
		}
		
		this.initEditorElements();
	}

	initEditorElements() {
		$('.editor').each(function(index, item) {
			// Salta se già inizializzato
			if ($(this).hasClass('note-editor') || $(this).data('summernote')) {
				return;
			}

			let customConfig = {};
			if ($(item).attr('data-config') != undefined) {
				customConfig = JSON.parse($(item).attr('data-config'));
			}

			// Rimuovi l'attributo required dal textarea perché viene nascosto da Summernote
			// e causerebbe errori di validazione HTML5 ("invalid form control is not focusable")
			$(this).removeAttr('required');

			$(this).summernote($.extend(true, {}, window.editorDefaultConfig, customConfig));
		});
	}

	// Funzione pubblica per reinizializzare editor su contenuto dinamico
	reinitializeEditors() {
		if (typeof window.$ !== 'undefined' && window.$.fn.summernote && window.editorDefaultConfig) {
			this.initEditorElements();
		}
	}

	iosCheckbox() {
		$('.ios-checkbox').iosCheckbox();
	}

	submitCRUDFormBtn() {
		$('body').on('click', '.do-action-and-new-btn', function(evt) {
			evt.preventDefault();
			let $form = $(this).data('form-target') ? $($(this).data('form-target')) : $(this).closest('form');

			if (!$form.length) {
				return;
			}

			$form.append('<input type="hidden" name="do_action_and_new" value="1"/>');
			$form.submit();
		});
	}

	submitFormWithConfirmation() {
		$('body').on('click', '.submit_btn_with_confirmation', function(evt) {
			evt.preventDefault();

			let confirmMessage = $(this).data('confirm_message');
			let form = $(this).closest('form');
			Swal.fire({
				text: confirmMessage,
				icon: 'warning',
				buttonsStyling: false,
				showCancelButton: true,
				cancelButtonText: _t('Cancel'),
				confirmButtonText: _t('Yes'),
				customClass: {
					confirmButton: 'btn btn-danger',
					cancelButton: 'btn btn-default',
				},
			}).then(function(result) {
				if (result.value) {
					form.submit();
				}
			});
		});
	}

	visibleIf() {
		let existCallback = function(element) {
			element.show();
		};
		let missingCallback = function(element) {
			element.hide();
		};
		this.selectorIf('visible-if', existCallback, missingCallback);
	}

	disabledIf() {
		let existCallback = function(element) {
			element.attr('disabled', true);
		};
		let missingCallback = function(element) {
			element.attr('disabled', false);
		};
		this.selectorIf('disabled-if', existCallback, missingCallback);
	}

	readonlyIf() {
		let existCallback = function(element) {
			element.attr('readonly', true);
		};
		let missingCallback = function(element) {
			element.attr('readonly', false);
		};
		this.selectorIf('readonly-if', existCallback, missingCallback);
	}

	selectorIf(cssClass, existCallback, missingCallback) {
		let _class = this;
		$('.' + cssClass).each(function() {
			let element = $(this);
			let targetValue = element.data('target-value');
			let targetElement = $('[name="' + element.data('target-name') + '"]');
			let targetValueSelector = '[name="' + element.data('target-name') + '"]';
			if (targetElement.length == 0) {
				return;
			}

			if ($(targetElement[0]).is(':checkbox') || $(targetElement[0]).is(':radio')) {
				targetValueSelector += ':checked';
			}

			_class.compareIf($(targetValueSelector).val(), targetValue, element, existCallback, missingCallback);

			targetElement.change(function() {
				_class.compareIf($(targetValueSelector).val(), targetValue, element, existCallback, missingCallback);
			});
		});
	}

	compareIf(currentValue, targetValue, element, existCallback, missingCallback) {
		let exist = false;
		if (Array.isArray(targetValue)) {
			if (Array.isArray(currentValue)) {
				for (let i = 0; i < currentValue.length; i++) {
					for (let j = 0; j < targetValue.length; j++) {
						if (targetValue[j] == currentValue[i]) {
							exist = true;
							break;
						}
					}
					if (exist == true) {
						break;
					}
				}
			} else {
				for (let j = 0; j < targetValue.length; j++) {
					if (targetValue[j] == currentValue) {
						exist = true;
						break;
					}
				}
			}
		} else {
			if (Array.isArray(currentValue)) {
				for (let i = 0; i < currentValue.length; i++) {
					if (targetValue == currentValue[i]) {
						exist = true;
						break;
					}
				}
			} else {
				if (targetValue == currentValue) {
					exist = true;
				}
			}
		}

		if (exist) {
			existCallback(element);
		} else {
			missingCallback(element);
		}
	}
}
